import { withoutCredentials } from './credential-url'
import { isTrackerFreePath } from './tracker-free-routes'

/**
 * Pushes a `pageview` event for a route change.
 * Next.js hands routeChangeComplete its in-memory asPath, which still holds a
 * sign-in token the address bar no longer shows. Dashboard URLs carry client
 * ids and never enter the dataLayer: GTM would replay them if it loaded on a
 * later page of the same document.
 * @param {string} url The new route's asPath.
 */
export const pageview = url => {
  if (isTrackerFreePath(url)) return
  window?.dataLayer?.push({
    event: 'pageview',
    page: withoutCredentials(url),
  })
}

/**
 * Pushes a page category, also as the event name.
 * @param {string} pc The page category.
 */
export const pageCategory = pc => {
  window?.dataLayer?.push({
    pageCategory: pc,
    event: pc,
  })
}

/**
 * Pushes an object onto the dataLayer, creating it if GTM has not loaded.
 * @param {object} payload The dataLayer entry.
 */
export const pushEvent = payload => {
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(payload)
}
